import {
  convertDateToYYYYMMDDFormat,
  convertEventSelectToTarget,
  CustomDateRangePicker,
  getFirstDayOfMonth,
  getToday,
  PageWrapper,
  Select,
} from '@repo/ui';
import { useFormik } from 'formik';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { Col, Row, Card, Label, Button, CardHeader } from 'reactstrap';
import * as Yup from 'yup';

import { ReportsGeneralFilters } from '../../Reports/components/reports-general-filters';
import { usePerformanceSpreadsheetReport } from '../hooks/usePerformanceSpreadsheetReport';

const PerformanceSpreadsheetReport = () => {
  const { currentUser } = useAuth();
  const { handlePerformanceSpreadsheetReport } =
    usePerformanceSpreadsheetReport();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      unit: null,
      groups: null,
      course: null,
      entity: null,
      semester: null,
      position: null,
      ends: convertDateToYYYYMMDDFormat(getToday()),
      starts: convertDateToYYYYMMDDFormat(getFirstDayOfMonth()),
    },
    validationSchema: Yup.object({
      unit: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      semester: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      entity: Yup.object()
        .shape({
          label: Yup.string().required('Campo é Obrigatório.'),
          value: Yup.string().required('Campo é Obrigatório.'),
        })
        .required('Campo é Obrigatório.')
        .nullable(),
      groups: Yup.array()
        .of(
          Yup.object()
            .shape({
              label: Yup.string(),
              value: Yup.string(),
            })
            .nullable(),
        )
        .nullable(),
      course: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      position: Yup.object()
        .shape({
          label: Yup.string(),
          value: Yup.string(),
        })
        .nullable(),
      starts: Yup.date().nullable().required('Campo é Obrigatório.'),
      ends: Yup.date().nullable().required('Campo é Obrigatório.'),
    }),

    onSubmit: (values) => {
      const groupsValues = values?.groups?.map((group) => group.value);
      handlePerformanceSpreadsheetReport({
        ends: values?.ends,
        groups: groupsValues,
        starts: values.starts,
        unit: values?.unit?.value,
        entity: values?.entity?.value,
        course: values?.course?.value,
        position: values?.position?.value,
        semester: values?.semester?.value,
        User: currentUser.id,
        Profile: String(currentUser.activeProfile.profileId),
      });
    },
  });

  return (
    <PageWrapper title="Planilha de Desempenho">
      <Row>
        <Col lg={12} md={12} xs={12}>
          <CardHeader className="mb-4 border-0">
            <h4>Planilha de Desempenho</h4>
          </CardHeader>
          <Card>
            <ReportsGeneralFilters
              buttonsChildren={
                <Col xs="4" md="4">
                  <div className="form-group d-flex justify-content-end align-items-center">
                    <Button color="primary" type="submit" id={'save_button'}>
                      Exportar para Excel
                      <i className="ri-file-excel-2-line mx-2"></i>
                    </Button>
                  </div>
                </Col>
              }
              inputsChildren={
                <>
                  <Col md={7} className="mb-3">
                    <Label htmlFor="final-date" className="form-label">
                      Cargo:
                    </Label>
                    <Select
                      isClearable
                      id="position"
                      name="position"
                      placeholder="Todos os Cargos"
                      value={validation.values.position}
                      onChange={(e) => {
                        validation.handleChange(
                          convertEventSelectToTarget('position', e),
                        );
                      }}
                      onBlur={validation.handleBlur}
                      options={[
                        {
                          label: 'Professor',
                          value: '7',
                        },
                        {
                          label: 'Preceptor',
                          value: '8',
                        },
                      ]}
                    />
                  </Col>
                  <Col sm={12} md={6} lg={4} className="mb-3">
                    <Row>
                      <Label htmlFor="initial-date" className="form-label">
                        Período
                      </Label>
                      <CustomDateRangePicker
                        initialStartDate={getFirstDayOfMonth()}
                        initialEndDate={getToday()}
                        placement="auto"
                        onDateChange={(start, ends) => {
                          validation.setFieldValue(
                            'starts',
                            convertDateToYYYYMMDDFormat(start),
                          );
                          validation.setFieldValue(
                            'ends',
                            convertDateToYYYYMMDDFormat(ends),
                          );
                        }}
                      />
                    </Row>
                  </Col>
                </>
              }
              validation={validation}
            />
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};

export default PerformanceSpreadsheetReport;
